<template>
  <div class="text-center pa-4">
    <v-dialog 
      v-model="dialog"
      transition="dialog-bottom-transition"
      fullscreen
      class="bg-grey-lighten-1"
    >

      <v-card class="bg-grey-lighten-1">
        <v-toolbar class="bg-grey-lighten-1" >
          <v-toolbar-title>Majed Photograph</v-toolbar-title>
          <v-toolbar-items>
            <v-btn
            icon="mdi-close"
            @click="closeDialog()"
            ></v-btn>
          </v-toolbar-items>
        </v-toolbar>

      <v-list class="bg-grey-lighten-1">
        <v-list-subheader>Übersicht</v-list-subheader>
      
      <!-- Kundenstimmen -->
      <v-list-item
        color="primary"
        @click="scrollToSection('TESTIMONIALS')"
      >
        <template v-slot:prepend>
          <v-icon color="green-darken-2">mdi-account-group</v-icon>
        </template>
        <v-list-item-title>Kundenstimmen</v-list-item-title>
      </v-list-item>

      <!-- Methodik -->
      <v-list-item
        color="primary"
        @click="scrollToSection('METHODOLOGY')"
      >
        <template v-slot:prepend>
          <v-icon color="orange-darken-2">mdi-lightbulb-on-outline</v-icon>
        </template>
        <v-list-item-title>Methodik</v-list-item-title>
      </v-list-item>

      <!-- Projekte -->
      <v-list-item
        color="primary"
        @click="scrollToSection('PROJECTS')"
      >
        <template v-slot:prepend>
          <v-icon color="blue-darken-2">mdi-briefcase-outline</v-icon>
        </template>
        <v-list-item-title>Projekte</v-list-item-title>
      </v-list-item>

      <!-- Q&A -->
      <v-list-item
        color="primary"
        @click="scrollToSection('AQ')"
      >
        <template v-slot:prepend>
          <v-icon color="purple-darken-2">mdi-comment-multiple-outline</v-icon>
        </template>
        <v-list-item-title>Q&A</v-list-item-title>
      </v-list-item>

      <!-- Über mich -->
      <v-list-item
        color="primary"
        @click="scrollToSection('ABOUT_ME')"
      >
        <template v-slot:prepend>
          <v-icon color="pink-darken-2">mdi-account-circle-outline</v-icon>
        </template>
        <v-list-item-title>Über mich</v-list-item-title>
      </v-list-item>

      <!-- Anfrage -->
      <v-list-item
        color="primary"
        @click="scrollToSection('CONTACT')"
      >
        <template v-slot:prepend>
          <v-icon color="red-darken-2">mdi-email-outline</v-icon>
        </template>
        <v-list-item-title>Anfrage</v-list-item-title>
      </v-list-item>

      <!-- Social Media -->
      <v-list-item
        color="primary"
        @click="scrollToSection('SOCIAL_MEDIA')"
      >
        <template v-slot:prepend>
          <v-icon color="cyan-darken-2">mdi-share-variant-outline</v-icon>
        </template>
        <v-list-item-title>Social Media</v-list-item-title>
      </v-list-item>
    </v-list>

      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { scrollService } from '@/services/scrollService';

export default defineComponent({
  name: 'NavbarPageComponent',

  props: {
    isActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      dialog: this.isActive as boolean,
      isRefClicked: false
    };
  },

  watch: {
    isActive: {
      immediate: true, // direkt beim Laden synchronisieren
      handler(newVal: boolean) {
        this.dialog = newVal;
      }
    },

    dialog(newVal: boolean) {
      this.$emit('update:isActive', newVal);
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    scrollToSection(section: string) {
      this.closeDialog();
      setTimeout(() => {
        scrollService.scrollToSection(section);
      }, 20);
    }

  },

});

</script>

<style scoped>
.v-list-item-title {
  font-size: 1rem;
  font-weight: bold;
}
</style>
